<template>
  <div style="display: inline-block; vertical-align: inherit;">
    <a-tooltip placement="top">
      <template slot="title">
        <span>{{ taskableDescription }}</span>
      </template>
      <a v-if :href="taskableLink" v-on:click.stop>
        {{ taskableName }}
      </a>
    </a-tooltip>
  </div>
</template>

<script>
export default {
  name: "TaskableBadgeComponent",
  props: {
    taskable: {
      type: Object,
      required: true
    }
  },
  computed: {
    taskableDescription() {
      return this.taskable.description;
    },
    taskableName() {
      return this.taskable.name;
    },
    taskableLink() {
      return this.taskable.link;
    }
  }
}
</script>
